<template>
	<component :is="component">
		<slot :task="task" :destroy="destroy" :done="done" :updateDone="updateDone"></slot>
	</component>
</template>
<script>
export default {
	data() {
		return {
			done: false,
		};
	},

	props: {
		component: {
			required: true,
			type: String,
		},
		task: {
			required: true,
			type: Object,
		},
	},

	methods: {
		destroy() {
			console.log("destroy", this.task.id);
			http().delete("tasks/" + this.task.id);
		},
		updateDone() {
			this.done = !this.done;
			this.update();
		},
		update() {
			http().patch("tasks/" + this.task.id, {
				complete: this.done,
				description: this.task.description,
				due_at: this.task.start_at ? moment(this.task.start_at).format("DD/MM/YYYY") : null,
			});
		}
	},

	created() {
		this.done = this.task.completed_at ? true : false;
	}
};
</script>
